// extracted by mini-css-extract-plugin
module.exports = {"root":"BannerIconSelect_root__393qw","iconOption":"BannerIconSelect_iconOption__1EV5M","selectedIconOption":"BannerIconSelect_selectedIconOption__mBpo4"};